module.exports = __webpack_public_path__ + "media/images/flags/DZ-4ac9e530219782891e6f961328256810.svg";